import * as React from "react"
import { type EntityTransaction } from "@digits-graphql/frontend/graphql-bearer"
import { VTable } from "@digits-shared/components/UI/VirtualizedTable/VTable"
import { TABLE_STYLE } from "src/frontend/components/Shared/Transactions/transactionsTableStyles"
import { useTableColumns } from "src/frontend/components/Shared/Transactions/useTableColumns"
import { useTransactionRowClick } from "src/frontend/components/Shared/Transactions/useTransactionRowClick"

/*
  INTERFACES
*/

interface TableProps {
  className?: string
  transactions: EntityTransaction[] | undefined
  loading?: boolean
}

/*
  COMPONENTS
*/

export const EntityTransactionsTable: React.FC<TableProps> = ({
  className,
  transactions,
  loading,
}) => {
  const onRowClick = useTransactionRowClick()
  const columns = useTableColumns({
    includeSources: false,
    includeRelatedCategory: false,
  })

  if (!transactions && !loading) return null

  return (
    <VTable
      className={className}
      css={TABLE_STYLE}
      loading={loading}
      data={transactions || []}
      columns={columns}
      estimateRowSize={() => 51}
      onRowClick={onRowClick}
    />
  )
}
